import { Component, Input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'rendelo-code-snippet',
  template: `
      <span>{{ title }}</span>
      <pre>{{ code }}</pre>
  `,
})
export class CodeSnippetComponent {
  @Input() code: string | undefined;
  @Input() title: string | null | undefined;
}
